// extracted by mini-css-extract-plugin
module.exports = {"warningSignal":"Indicators_warningSignal__r-r6T","selector":"Indicators_selector__3gnXJ","approveButton":"Indicators_approveButton__BQ-mq"};